import * as m from "mithril";
import { MoneyDTO, SeatSelectionDTO } from "../../apiclient/ApiDtos";
import { MessageProvider } from "../../context/AppMessages";
import { formatMoney } from "../../helpers/MoneyFormatter";


interface Attrs {
  messageProvider: MessageProvider;
  seatSelections: SeatSelectionDTO[];
}

export function SeatsAutoAssignmentInfo(): m.Component<Attrs> {

  return {

    view(vnode) {
      const { messageProvider, seatSelections } = vnode.attrs;

      const totalAmount = seatSelections.reduce(
        (acc, seat) => acc + seat.price.amount,
        0
      );

      const totalSeatPrice: MoneyDTO = {
        amount: totalAmount,
        currency: "MMK"
      };

      return m("div",
        m("div.important-info-alert mb-3 small font-weight-bold",
          vnode.attrs.messageProvider.get("small_car_details.seating_is_auto")
        ),
        m("div",
          m(".row.mt-3",
            m(".col-6",
              m("span.mr-2 small", messageProvider.get("price_per_seat"))
            ),
            m(".col-6.text-right",
              m("span.text-success.font-weight-bold_",
                seatSelections.length > 0 ? formatMoney(seatSelections[0].price) : null
              )
            )
          ),
          m("div.d-flex mt-3 justify-content-between small",
            m("div", vnode.attrs.messageProvider.get("no_of_seats")),
            m("div.ml-3 font-weight-bold", vnode.attrs.seatSelections.length,
              " ",
              vnode.attrs.seatSelections.length > 1 ?
                vnode.attrs.messageProvider.get("seats") :
                vnode.attrs.messageProvider.get("seat")

            )
          ),

          m(".row.mt-3",
            m(".col-6",
              m("span.mr-2 small", messageProvider.get("total_seat_price"))
            ),
            m(".col-6.text-right",
              m("span.text-success.font-weight-bold",
                seatSelections.length > 0 ? formatMoney(totalSeatPrice) : null
              )
            )
          )

        ),

      );
    }
  };
}
